"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var configuration_1 = require("./configuration");

var validation_1 = require("../../validation");

var defaults_1 = require("../../defaults");

var WashBasinDimensionKeys;

(function (WashBasinDimensionKeys) {
  WashBasinDimensionKeys["AngleOfNiche"] = "angleOfNiche";
  WashBasinDimensionKeys["CornerDesign"] = "cornerDesign";
  WashBasinDimensionKeys["CornerDesignPosition"] = "cornerDesignPosition";
  WashBasinDimensionKeys["Distances"] = "distances";
  WashBasinDimensionKeys["PlateDepth"] = "plateDepth";
  WashBasinDimensionKeys["PlateWidth"] = "plateWidth";
  WashBasinDimensionKeys["TypeOfInstallation"] = "typeOfInstallation";
  WashBasinDimensionKeys["PlateDimensionsAcceptedNicheTip"] = "plateDimensionsAcceptedNicheTip";
})(WashBasinDimensionKeys = exports.WashBasinDimensionKeys || (exports.WashBasinDimensionKeys = {}));

var WashBasinDimension =
/** @class */
function (_super) {
  __extends(WashBasinDimension, _super);

  function WashBasinDimension() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  WashBasinDimension.prototype.handle = function (postAdjust) {
    var _this = this;

    if (postAdjust === void 0) {
      postAdjust = true;
    }

    if (this.prevKey && this[this.prevKey] === null) {
      return null;
    }

    var data = {};
    Object.keys(WashBasinDimensionKeys).forEach(function (key) {
      var _a;

      return lodash_1.assign(data, (_a = {}, _a[WashBasinDimensionKeys[key]] = _this[WashBasinDimensionKeys[key]], _a));
    });
    return data;
  };

  WashBasinDimension.prototype.handleDefaults = function () {
    var defaults = this.default;
    var data = this.handle(false);

    if (this.plateBuilder && this.trough) {
      defaults.plateWidth = validation_1.assignDefaultWidth(this.plateBuilder.calc.plateWidthRange());
      defaults.plateDepth = validation_1.assignDefaultDepth(this.plateBuilder.calc.plateDepthRange(), this.trough); // const getDistances = this.calculator && this.calculator.getDistances(this.resetDistances);

      var troughPositions = this.plateBuilder.calc.troughInitialPositions();
      defaults.distances = {
        default: troughPositions,
        values: null
      };

      if (data) {
        if (data.cornerDesign) {
          defaults = validation_1.validateCornerDesign(data, defaults);

          if (validation_1.isInstanceOfError(defaults)) {
            return defaults;
          }

          defaults.cornerDesign.default = data.cornerDesign;
        }

        if (data.plateWidth && data.plateWidth > 0) {
          defaults = validation_1.validatePlateWidth(data, this.plateBuilder.calc.plateWidthRange(), defaults);

          if (validation_1.isInstanceOfError(defaults)) {
            return defaults;
          }
        }

        if (data.plateDepth && data.plateDepth > 0) {
          if (this.isNewTrough) {
            defaults.plateDepth = this.plateDepthDefaults ? this.plateDepthDefaults : defaults_1.configurationDefaults.washBasinDimension.plateDepth;
          }

          defaults = validation_1.validatePlateDepth(data, defaults);

          if (validation_1.isInstanceOfError(defaults)) {
            return defaults;
          }
        }
      }
    }

    return defaults;
  };

  Object.defineProperty(WashBasinDimension.prototype, "angleOfNiche", {
    get: function get() {
      if (!this.washBasinDimension) {
        return this.getDefault(configuration_1.ConfigurationKeys.WashBasinDimension, WashBasinDimensionKeys.AngleOfNiche).default;
      }

      if (this.isNewTypeOfInstallation) {
        if (this.typeOfInstallation === 'left' || this.typeOfInstallation === 'right') {
          return [90];
        }

        if (this.typeOfInstallation === 'with') {
          return [90, 90];
        }

        if (this.typeOfInstallation === 'without') {
          return null;
        }
      }

      return this.washBasinDimension.angleOfNiche;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(WashBasinDimension.prototype, "cornerDesign", {
    get: function get() {
      if (!this.washBasinDimension) {
        return this.getDefault(configuration_1.ConfigurationKeys.WashBasinDimension, WashBasinDimensionKeys.CornerDesign).default;
      }

      return this.washBasinDimension.cornerDesign;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(WashBasinDimension.prototype, "cornerDesignPosition", {
    get: function get() {
      if (!this.washBasinDimension) {
        return this.getDefault(configuration_1.ConfigurationKeys.WashBasinDimension, WashBasinDimensionKeys.CornerDesignPosition).default;
      }

      return this.washBasinDimension.cornerDesignPosition;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(WashBasinDimension.prototype, "distances", {
    get: function get() {
      if (this.washBasinDimension && this.washBasinDimension.distances && !this.resetDistances) {
        return this.washBasinDimension.distances;
      }

      if (this.plateBuilder) {
        return this.plateBuilder.calc.troughInitialPositions();
      }

      return this.getDefault(configuration_1.ConfigurationKeys.WashBasinDimension, WashBasinDimensionKeys.Distances).default;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(WashBasinDimension.prototype, "plateDepth", {
    get: function get() {
      if (!this.washBasinDimension || this.isNewTrough) {
        if (this.plateBuilder && this.trough && this.trough.preparedBackWallWith) {
          return this.plateBuilder.calc.plateMinDepth();
        } else {
          return this.plateDepthDefaults.default;
        }
      }

      return this.washBasinDimension.plateDepth;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(WashBasinDimension.prototype, "plateDepthDefaults", {
    get: function get() {
      var depthDefaults = this.plateBuilder && this.trough && validation_1.assignDefaultDepth(this.plateBuilder.calc.plateDepthRange(), this.trough);
      return depthDefaults || defaults_1.configurationDefaults.washBasinDimension.plateDepth;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(WashBasinDimension.prototype, "plateWidth", {
    get: function get() {
      var minPlateWidth = this.plateBuilder && this.plateBuilder.calc.plateMinWidth().total || 0;

      if (!this.washBasinDimension) {
        if (minPlateWidth && minPlateWidth > 0) {
          return minPlateWidth;
        }

        return this.getDefault(configuration_1.ConfigurationKeys.WashBasinDimension, WashBasinDimensionKeys.PlateWidth).default;
      }

      if (this.isNewQty || this.isNewTrough || this.isNewQty && this.washBasinDimension.plateWidth >= minPlateWidth || this.washBasinDimension.plateWidth <= minPlateWidth) {
        return minPlateWidth;
      }

      return this.washBasinDimension.plateWidth;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(WashBasinDimension.prototype, "typeOfInstallation", {
    get: function get() {
      if (!this.washBasinDimension) {
        return this.getDefault(configuration_1.ConfigurationKeys.WashBasinDimension, WashBasinDimensionKeys.TypeOfInstallation).default;
      }

      return this.washBasinDimension.typeOfInstallation;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(WashBasinDimension.prototype, "plateDimensionsAcceptedNicheTip", {
    get: function get() {
      if (!this.washBasinDimension) {
        return this.getDefault(configuration_1.ConfigurationKeys.WashBasinDimension, WashBasinDimensionKeys.PlateDimensionsAcceptedNicheTip).default;
      }

      return this.washBasinDimension.plateDimensionsAcceptedNicheTip;
    },
    enumerable: true,
    configurable: true
  });
  return WashBasinDimension;
}(configuration_1.Configuration);

exports.WashBasinDimension = WashBasinDimension;